import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { BotonDGView } from "./boton";

const iconos = {
    misEnvios: require("app/img/iconos/misenvios.png"),
    cotizar: require("app/img/iconos/cotizar.png"),
    tuEmpresa: require("app/img/iconos/tuempresa.png")
};

export interface CotizadorProps {
    onClick?: () => void;
}

export class CotizadorButton extends React.PureComponent<CotizadorProps> {
    render() {
        return (
            <BotonDGView
                text="COTIZADOR"
                width="250px"
                height="78px"
                icon={iconos.cotizar}
                iconStyle="center"
                style="dark"
                disableMargin
                onClick={() => history.go("/operativa/cotizar")}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/botones.tsx